export default __webpack_public_path__ + "static/media/stepsSecondFrame.163477b3.svg";